/** Position the native, non-modal popover; the browser handles Escape and outside clicks. */
class HeaderContact extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    const panel = this.querySelector('[popover]');
    const trigger = this.querySelector('[popovertarget]');
    if (!panel || !trigger) return;

    const position = () => {
      if (!panel.matches(':popover-open')) return;
      panel.style.maxHeight = `${Math.max(0, innerHeight - 32)}px`;
      const rect = trigger.getBoundingClientRect();
      const gutter = 16;
      const left = Math.max(gutter, Math.min(rect.right - panel.offsetWidth, innerWidth - panel.offsetWidth - gutter));
      const top = Math.max(gutter, Math.min(rect.bottom + 8, innerHeight - panel.offsetHeight - gutter));
      panel.style.left = `${left}px`;
      panel.style.right = 'auto';
      panel.style.top = `${top}px`;
      panel.style.maxHeight = `${Math.max(0, innerHeight - top - gutter)}px`;
    };

    panel.addEventListener('toggle', () => {
      const open = panel.matches(':popover-open');
      trigger.setAttribute('aria-expanded', String(open));
      if (open) position();
    }, { signal });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !panel.matches(':popover-open')) return;
      event.preventDefault();
      panel.hidePopover();
      trigger.focus();
    }, { signal });
    window.addEventListener('resize', position, { signal });
    document.addEventListener('scroll', position, { signal, capture: true, passive: true });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('pbc-header-contact')) customElements.define('pbc-header-contact', HeaderContact);
